import ClubFee from '../../dto/ClubFee.js';
import Error from '../../model/Error.js';
import axios from 'axios';

export default class ClubSalesListOfferingItemRepository {
    static findByClubId(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/sales-list/offering-items`)
                .then(response => resolve(response.data.data.map(data => ClubFee.fromDataForSalesListOfferingItem(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
